import { memo } from 'react';
import { Button, CircularProgress, DialogContent, styled, Typography } from '@mui/material';
import { FlexBox, HandlerError } from '@dfl/mui-react-common';
import { useTranslation } from 'react-i18next';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

type ExportingStateProps = {
  error: any;
  status?: string;
  onRetry?: () => void;
};

export const Loading = styled('div')(() => ({
  position: 'relative',
  marginBottom: 20,
  '.export-icon': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    fontSize: '80px',
    marginLeft: '-40px',
    marginTop: '-40px',
  },
}));

const ExportingState = ({ error, status, onRetry }: ExportingStateProps) => {
  const { t } = useTranslation('common');

  const getStatusKey = (currentStatus?: string): string => {
    switch (currentStatus) {
      case 'QUEUED':
        return 'exportDialog.status.queued';
      case 'PROCESSING':
        return 'exportDialog.status.processing';
      case 'GENERATING':
        return 'exportDialog.status.generating';
      default:
        return 'exportDialog.exporting';
    }
  };

  return (
    <DialogContent sx={{ padding: '20px 40px' }}>
      <FlexBox flexDirection={'column'} alignItems={'center'} justifyContent={'center'} mt={2}>
        <Loading>
          <FileDownloadOutlinedIcon color={error ? 'error' : 'primary'} className={'export-icon'} />
          <CircularProgress
            size={109}
            color={error ? 'error' : 'primary'}
            value={100}
            variant={error ? 'determinate' : 'indeterminate'}
          />
        </Loading>
        <HandlerError error={error} />
        <Typography variant={'h2'} mb={1}>
          {t(!error ? getStatusKey(status) : 'export')}
        </Typography>
        <Typography mb={4} maxWidth={400} textAlign={'center'}>
          {t('exportDialog.exportingTime')}
        </Typography>
        {error && onRetry && (
          <Button variant='contained' color='primary' onClick={onRetry} sx={{ mt: 1 }}>
            {t('retry')}
          </Button>
        )}
      </FlexBox>
    </DialogContent>
  );
};

export default memo(ExportingState);
